import { SpinnerGap } from "@phosphor-icons/react";

import styles from "./loading-spinner.module.css";

/*
 * The last local primitive without a design-system equivalent. The DS ships a
 * Skeleton, which is a different thing: a placeholder in the shape of content
 * that is about to appear. Pages whose body is swapped out while it loads use
 * that instead (Analytics, Revenue, Promo codes). What is left here is the
 * cases a skeleton cannot express - a scrim over content that is still on
 * screen, and a wait beside a button that has just been pressed - so the
 * spinner stays, on design-system tokens rather than a hand-picked white.
 */

type LoadingSpinnerProps = {
  size?: number;
  label?: string;
  className?: string;
};

export function LoadingSpinner({ size = 24, label, className }: LoadingSpinnerProps) {
  return (
    <div
      className={[styles.spinner, className].filter(Boolean).join(" ")}
      role="status"
      aria-live="polite"
    >
      <SpinnerGap size={size} className={styles.icon} aria-hidden="true" />
      {label ? <span className={styles.label}>{label}</span> : null}
    </div>
  );
}
